import useCurrentUser from "hooks/useCurrentUser";
import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

const UnprotectedRoutes = () => {
    const token = localStorage.getItem('token');
    const { setToken } = useCurrentUser();

    useEffect(() => {
        setToken(token)
    }, [token])

    if (token) {
        return <Navigate to="/dashboard" />
    }

    return <Outlet />
}
export default UnprotectedRoutes;